import { AnimatePresence, motion } from "framer-motion";

const LOGO_ROUND =
    "https://customer-assets-jt897jd0.emergentagent.net/job_18a53554-3c4c-4394-97e9-2d39c51c5281/artifacts/4eg9cvl3_232787.jpg";

const Loader = ({ show }) => {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    key="loader"
                    initial={{ opacity: 1 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
                    className="fixed inset-0 z-[100] flex items-center justify-center"
                    style={{ background: "var(--bg-primary)" }}
                >
                    <div className="grain absolute inset-0 pointer-events-none" />
                    <div className="relative flex flex-col items-center gap-6">
                        <motion.div
                            initial={{ scale: 0.7, opacity: 0, rotate: -20 }}
                            animate={{ scale: 1, opacity: 1, rotate: 0 }}
                            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                            className="relative w-28 h-28 rounded-full overflow-hidden anim-spin"
                            style={{ animationDuration: "6s", boxShadow: "0 25px 60px -20px rgba(232,58,116,0.6)" }}
                        >
                            <img src={LOGO_ROUND} alt="loading" className="w-full h-full object-cover" />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.5, duration: 0.7 }}
                            className="font-body text-[10px] uppercase tracking-[0.36em]"
                            style={{ color: "var(--ink-mute)" }}
                        >
                            unwrapping the party
                        </motion.div>
                        <motion.div
                            className="relative h-px w-40 overflow-hidden"
                            style={{ background: "rgba(46,16,37,0.15)" }}
                        >
                            <motion.span
                                initial={{ x: "-100%" }}
                                animate={{ x: "100%" }}
                                transition={{ duration: 1.6, repeat: Infinity, ease: "linear" }}
                                className="absolute inset-y-0 left-0 w-1/2"
                                style={{ background: "var(--pink)" }}
                            />
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Loader;
